// extracted by mini-css-extract-plugin
module.exports = {"content":"Lightbox-module-content","overlay":"Lightbox-module-overlay","base":"Lightbox-module-base","visible":"Lightbox-module-visible","closeIcon":"Lightbox-module-close-icon"};